import { UpdateListColumnsColumnDto } from "@advanced-sales-technologies/backend-client/models/UpdateListColumnsColumnDto";
import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type SearchParams = {
  listId: string;
  columnOrder: UpdateListColumnsColumnDto[];
};

export const useUpdateOrderColumns = () => {
  const { apiClient } = useSalesyApiClient();

  const updateOrderColumns = async (searchParams: SearchParams) => {
    return apiClient.lists.updateColumns({
      id: searchParams.listId,
      requestBody: { columns: searchParams.columnOrder },
    });
  };

  const mutation = useMutation({
    mutationKey: ["update-order-columns"],
    mutationFn: updateOrderColumns,
  });

  return {
    ...mutation,
    updateOrderColumns: mutation.mutate,
  };
};
